import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,OnDestroy } from "@angular/core";
import { ClaimsService } from "../../_services/common/claims.service";
import { Claims } from "../../_models/common/claims";
import { AppGridComponent } from "../../shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { CountByStatus, GridConfig } from "../../_models/common/grid/grid-config";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { TaxRateService } from "../../_services/tax-rate/tax-rate.service";
import { TaxSetupResponseInfo } from "../../_models/tax-rate/tax-setup-response";
import { ApiRequest, EmployeeActionsEnum, FunctionPackageEnum, LogObjectActionTemplateEnum, TaxActionEnum, TaxRateComponentStatusEnum, TaxRateStatusEnum } from "../../_models";
import {
  TaxRateMasterRequest,
  TaxRateMasterRequestInfo
} from "../../_models/tax-rate/tax-rate-master-request";
import { environment } from "../../../environments/environment";
import { TaxRateComponentResponseInfo } from "../../_models/tax-rate/tax-rate-component-response";
import { TaxRateMasterResponseInfo } from "../../_models/tax-rate/tax-rate-master-response";
import { LoggingPanelModel } from "../../_models/common/LoggingPanelModel";
import { LoggingPanelService } from "../../_services/logging-panel/logging-panel.service";
import {
  TaxRateComponentRequestInfo,
  TaxRateComponentRequest,
  TaxRateComponentSaveRequest,
} from "../../_models/tax-rate/tax-rate-component-request";
import {
  TaxSetupRequest,
  TaxSetupRequestInfo,
} from "../../_models/tax-rate/tax-setup-request";
import { FlatpickrOptions } from "ng2-flatpickr";
import { Subscription } from "rxjs";
import { AssignTaxToCategoryListPanelInputModel } from "../../_models/manage-category/expense-category";
import { AlertPanelModel } from "../../_models/common/alertPanelModel";
import { ToastrService } from "ngx-toastr";
import { AlertService } from "../../alert-panel/alert.service";
import { TourService } from '../../_tour/tour.service';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared.module";
import { GridModule } from "src/app/_modules/modules/grid.module";
@Component({
    selector: 'app-tax-setup-step2',
    templateUrl: './tax-setup-step2.component.html',
    standalone: true,
      imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    GridModule
  ]
})

export class TaxSetupStep2Component implements OnInit,OnDestroy {
  @Input() fmSpecialObject: any;
  @Input() panelHeader: string;
  @Input() IsSingleRate: boolean;
  @Input() pattern: string | RegExp;
  @Output() closePanelEvent = new EventEmitter<boolean>();
  claims: Claims;
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  gridConfigItems: GridConfig;
  gridColumnDefs: ColDef[];
  gridData: any;
  videoLink: string;
  OrganisationId: number;
  TaxSetup: TaxSetupResponseInfo;
  TaxRateMasterList: TaxRateMasterResponseInfo[];
  TaxRateMasterListOriginal: TaxRateMasterResponseInfo[];
  MaxNumberOfComponents: number = 0;
  CanCreateFutureRate: boolean;
  ActiveTaxCount: number;
  FutureTaxCount: number;
  InActiveTaxCount: number;
  currentStatus: number;
  hasFormChanges: boolean;
  gridFilterStatus: number = TaxRateStatusEnum.Active;
  ComponentsArray: number[];
  TaxRateMasterId: number = 0;
  TaxRateCompoentList: TaxRateComponentResponseInfo[];
  taxSetupText: string;

  searchText: string;
  PageTitle: string;
  CurrentTaxMasterId: number = 0;
  CreateNewTaxHeader: string;
  IsCreateNewTaxRateMaster: boolean;
  howDoIVideoLinks = HowDoIVideoLinks;

  TaxSetupRequest: TaxSetupRequest;
  TaxRateMasterRequestInfo: TaxRateMasterRequestInfo;
  TaxRateMasterRequest: TaxRateMasterRequest;
  TaxRateMasterResponseInfo: TaxRateMasterResponseInfo;
  TaxRateMasterListForFutureRate: any[];
  TaxRateCompoentRequest: TaxRateComponentRequest;
  taxRateComponentSaveRequest: TaxRateComponentSaveRequest;

  DesctivateConfirmation: boolean;
  DesctivateConfirmationHeader: string;
  DesctivateConfirmationText: string;

  ShowDataInGrid: boolean;

  ShowEditPanel: boolean;
  ShowLogPanel: boolean;
  DisableSave: boolean;

  ShowCreateNewTaxRate: boolean;
  IsNoRecords: boolean;

  TaxCode: string;
  TaxRate: string;
  TaxAccountingCode: string;
  EffectiveFrom: any;
  TaxActiveStatus: boolean;

  ShowFutureRate: boolean;
  ShowExpiredRate: boolean;

  ExpiredTaxRateMasterList: TaxRateMasterResponseInfo[];
  FutureTaxRateMasterList: TaxRateMasterResponseInfo[];

  currentDeactivatingItem: TaxRateMasterResponseInfo;

  Submitted: boolean;
  sortColumn: string = "TaxCode";
  sortOrderDesc: boolean = false;

  TotalTaxRate: number;
  showTaxRateValidation: boolean;
  showDuplicateTaxRateValidation: boolean;

  IsFutureRate: boolean;
  FutureRateOf: number;
  param: any;

  isTaxCodeAlreadyExists: boolean;
  functionPackageEnum = FunctionPackageEnum;

  showMarketingPopup: boolean;
  manageCategoryMarketingPopupModel: any;

  datePickerOptions: FlatpickrOptions = {
    mode: "single",
    defaultDate: new Date(),
    maxDate: new Date(new Date().setHours(23, 59, 59, 999)),
    altInput: true,
    altFormat: "d-M-Y",
    dateFormat: "d-M-Y",
  };

  futureDatePickerOptions: FlatpickrOptions = {
    mode: "single",
    defaultDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    minDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    altInput: true,
    altFormat: "d-M-Y",
    dateFormat: "d-M-Y",
  };

  alertSubscription: Subscription;
  @ViewChild("fFrmDate") fFrmDate: any;

  showAssignTaxToCategoryListPanel: boolean = false;
  assignTaxToCategoryListPanelInputModel: AssignTaxToCategoryListPanelInputModel;

  @ViewChild('componentRateCollapse') componentRateCollapse!: ElementRef;


  constructor(
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private taxRateService: TaxRateService,
    private loggingPanelService: LoggingPanelService,
    private toastr: ToastrService,
    private alertService: AlertService,
    private tourService: TourService,
    private route: ActivatedRoute,
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
      this.OrganisationId = this.claims.OrgId;
    });
    this.taxSetupText = this.translate.instant('tax_code');
    this.alertSubscription = this.alertService
      .getUserActionEvent()
      .subscribe((action) => {
        if (action) {
          this.ShowEditPanel = false;
          this.hasFormChanges = false;
        }
      });
  }

  ngOnInit() {
   
    this.gridData = [];
    this.ComponentsArray = [];
    this.videoLink = this.IsSingleRate ? HowDoIVideoLinks.TaxRateSetupStep3withoutComponents : HowDoIVideoLinks.TaxRateSetupStep3withComponents;
    this.fnInitialiseGrid();
    this.BindTaxRateMaster();
  }

    ngOnDestroy() {
      this.tourService.destroyParallelPopups();
    }

  fnBacktoWizard() {
    this.closePanelEvent.emit(true);
  }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid(false);
    }, 100);
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant('tax_code'),
        field: 'taxCode',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
        width: 100
      },
      {
        headerName: this.translate.instant('tax_rate_percent'),
        field: 'taxRateString',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
        width: 100,
        cellClass: 'text-right',
        headerClass: 'text-right'
      },
      {
        headerName: this.translate.instant('tax_accounting_code'),
        field: 'taxAccountingCode',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 200,
        width: 200
      },
      {
        headerName: this.translate.instant('uk_mileage_effective_from'),
        field: 'effectiveFrom',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
        width: 100,
        cellRenderer: 'dateRenderer'
      }]

    if (!this.IsSingleRate) {
      this.ComponentsArray.forEach((item) => {
        this.gridColumnDefs.push(
          {
            headerName: this.translate.instant('component') + " " + item,
            field: 'component' + item,
            resizable: true,
            sortable: true,
            suppressHeaderMenuButton: true,
            minWidth: 100,
            width: 100,
            cellClass: 'text-right',
            headerClass: 'text-right'
          });
      });
    }

    this.gridColumnDefs.push(
      {
        headerName: this.translate.instant('label_status'),
        field: 'status',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
        width: 100,
        cellRenderer: "fieldValueRenderer",
        headerComponentParams: [
          {
            class: "active-color font-weight-bold",
            value: TaxRateComponentStatusEnum.Active,
            text: this.translate.instant("label_active"),
          },
          {
            class: "pending-color font-weight-bold",
            value: TaxRateComponentStatusEnum.Future,
            text: this.translate.instant("future_rate"),
          },
          {
            class: "inactive-color font-weight-bold",
            value: TaxRateComponentStatusEnum.Inactive,
            text: this.translate.instant("label_inactive"),
          }]
      },
      {
        headerName: "",
        valueGetter: 'data && data.taxRateMasterId',
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        sortable: false,
        minWidth: 100,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-edit color-green',
              buttonTooltip: this.translate.instant('label_edit'),
              userAction: TaxActionEnum.Edit
            },
            {
              buttonClass: 'fas icon-Red fa-trash-alt',
              buttonTooltip: this.translate.instant('label_delete'),
              userAction: TaxActionEnum.Delete,
              hideProperty: "hideDelete"
            }
          ]
      });

  }

  fnGetGridConfigItems() {
    let countByStatusArray = [];
    countByStatusArray.push(new CountByStatus("d-block cursor-pointer", this.translate.instant('total_tax_codes'), this.TotalTaxCount, false, 0));
    countByStatusArray.push(new CountByStatus("d-inline-block padding-left-10 icon-Green text-underline padding-right-10 lH-12 cursor-pointer ", this.translate.instant('label_active'), this.ActiveTaxCount, true, TaxRateStatusEnum.Active));
    countByStatusArray.push(new CountByStatus("d-inline-block color-light-grey padding-left-10 padding-right-10 text-underline border-left-2px lH-12 cursor-pointer ", this.translate.instant('label_inactive'), this.InActiveTaxCount, true, TaxRateStatusEnum.Inactive));
    countByStatusArray.push(new CountByStatus("d-inline-block icon-Orange padding-left-10 text-underline border-left-2px lH-12 cursor-pointer ", this.translate.instant('future_rate'), this.FutureTaxCount, true, TaxRateStatusEnum.FutureRate));

    this.gridConfigItems = new GridConfig(
      false,
      false,
      "taxCode",
      "taxRateMasterId",
      0,
      false,
      countByStatusArray,
      true,
      true,
      false,
      null,
      'asc',
      40,
      this.translate.instant('no_data_availabe'),
      null,
      null,
      false,
      false,
      '',
      '',
      false
    );
  }

  fnGridFilterChanged(filterStatus: number) {
    this.gridFilterStatus = filterStatus;
    switch (this.gridFilterStatus) {
      case 0: this.gridData = this.TaxRateMasterList.filter((item) => item.isActive == true && item.isFutureRate == false).map(e => this.mapSetupComponentRate(e));
        break;
      case 1: this.gridData = this.TaxRateMasterList.filter((item) => item.isActive == false).map(e => this.mapSetupComponentRate(e));
        break;
      case 2: this.gridData = this.TaxRateMasterList.filter((item) => item.isActive == true && item.isFutureRate == true).map(e => this.mapSetupComponentRate(e));
        break;
    }
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.refreshGridData();
    }, 100);
  }

  fnOnGridCellClick(params) {
    switch (params.column.colId) {
      case 'userActionField':
        switch (params.data.userAction) {
          case TaxActionEnum.Edit:
            this.EditExistingTaxRate(params.data);
            break;
          case TaxActionEnum.Delete:
            this.DeactivateExistingTaxRate(params.data);
            break;
        }
    }
  }

  OnTaxComponentChange() {
    this.hasFormChanges = true;
    this.TotalTaxRate = this.TaxRateCompoentList.reduce(
      (sum, item) => Number(sum) + Number(item.taxRate.toString().replace('%', '')),
      0
    );
  }

  IsNumericCheck(value) {
    return !isNaN(value.replace("%", ""));
  }

  omit_special_char(event) {
    if (
      (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 37) &&
      this.IsNumericCheck(event.target.value.toString() + event.key)
    ) {
      // let it happen, don't do anything
    } else {
      // Ensure that it is a number and stop the keypress
      if (
        event.keyCode < 48 ||
        event.keyCode > 57 ||
        !this.IsNumericCheck(event.target.value.toString() + event.key)
      ) {
        event.preventDefault();
      }
    }
  }

  TotalTaxCount: number;
  BindTaxRateMaster() {
    let apiRequest = new ApiRequest<TaxRateMasterRequestInfo>(
      "GetAllTaxRates",
      environment.applicationVersion,
      environment.requestId
    );
    var request = new TaxRateMasterRequestInfo();
    request.organisationId = this.OrganisationId;
    apiRequest.requestInfo = request;
    this.taxRateService
      .getTaxRateMasterByOrgId(apiRequest)
      .pipe()
      .subscribe((data) => {
        if (data.statusCode == 0) {
          this.TaxRateMasterList = data.responseInfo;
          this.TaxRateMasterListOriginal = this.TaxRateMasterList;
          this.CanCreateFutureRate =
            this.TaxRateMasterList.filter((item) => item.isFutureRate !== true)
              .length > 0;
          this.TaxRateMasterList = this.TaxRateMasterListOriginal.filter(
            (i) => i.isExpiredRate === false
          );
          for (var i = 0; i < this.TaxRateMasterList.length; i++) {
            this.BindTaxRateComponentsForMaster(
              this.TaxRateMasterList[i].taxRateComponent
            );
          }

          this.ActiveTaxCount = this.TaxRateMasterList.filter(
            (item) => item.isActive == true && item.isFutureRate == false
          ).length;

          this.FutureTaxCount = this.TaxRateMasterList.filter(
            (item) => item.isActive == true && item.isFutureRate == true
          ).length;

          this.InActiveTaxCount = this.TaxRateMasterList.filter(
            (item) => item.isActive == false
          ).length;
          this.TotalTaxCount = this.ActiveTaxCount + this.FutureTaxCount + this.InActiveTaxCount;
        }

        this.gridFilterStatus = this.ActiveTaxCount > 0 ? TaxRateStatusEnum.Active : TaxRateStatusEnum.Inactive;
        this.fnGridFilterChanged(this.gridFilterStatus);
         if(this.fmSpecialObject) {
            if(this.fmSpecialObject.type === 1) {
              this.CreateNewTaxRate();
            }
            
          }

          this.fnStartTour();
      });
  }

  BindTaxRateComponentsForMaster(response: TaxRateComponentResponseInfo[]) {
    if (response != null) {
      if (this.MaxNumberOfComponents < response.length) {
        this.MaxNumberOfComponents = response.length;
        this.SetComponetsArray();
      }
    }
  }

  SetComponetsArray() {
    this.ComponentsArray = [];
    for (let i = 1; i <= this.MaxNumberOfComponents; i++) {
      this.ComponentsArray.push(i);
    }
  }

  mapSetupComponentRate(e): any {
    var i = 0;
    let taxRateComponentDetail: any = e;
    taxRateComponentDetail.taxRateString = e.taxRate.toFixed(2) + '%';
    taxRateComponentDetail.taxRateComponent.forEach(element => {
      i++;
      taxRateComponentDetail['component' + i] = element.taxRate.toFixed(2) + '%';
    });
    if (taxRateComponentDetail.isActive && taxRateComponentDetail.isFutureRate == false)
      taxRateComponentDetail.status = TaxRateComponentStatusEnum.Active;
    else if (!taxRateComponentDetail.isActive)
      taxRateComponentDetail.status = TaxRateComponentStatusEnum.Inactive;
    else if (taxRateComponentDetail.isActive && taxRateComponentDetail.isFutureRate)
      taxRateComponentDetail.status = TaxRateComponentStatusEnum.Future;

    if (taxRateComponentDetail.isActive && taxRateComponentDetail.isFutureRate)
      taxRateComponentDetail.hideDelete = false;
    else
      taxRateComponentDetail.hideDelete = true;
    return taxRateComponentDetail;
  }

  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.TaxRateWithComponenets.toString(),
      this.TaxRateMasterId.toString()
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  CreateNewTaxRate() {
    this.Submitted = false;
    this.TaxRateMasterId = 0;
    this.TaxCode = "";
    this.TaxRate = null;
    this.TaxAccountingCode = "";
    this.TaxRateBeforeEdit = "";
    this.IsCreateNewTaxRateMaster = true;
    this.CreateNewTaxHeader = this.translate.instant('create_new_tax_code');
    this.ShowEditPanel = true;
    this.ShowLogPanel = false;
    this.IsFutureRate = false;

    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    sixMonthsAgo.setHours(0, 0, 0, 0);

    this.EffectiveFrom = sixMonthsAgo;
    this.datePickerOptions = {
      mode: "single",
      defaultDate: sixMonthsAgo,
      maxDate: new Date(new Date().setHours(23, 59, 59, 999)),
      altInput: true,
      altFormat: "d-M-Y",
      dateFormat: "d-M-Y",
    };
    this.fFrmDate.nativeElement.flatpickr(this.datePickerOptions);
    this.ShowExpiredRate = false;
    this.ShowFutureRate = false;
    this.isTaxCodeAlreadyExists = false;

    if (!this.IsSingleRate) {
      this.TaxRateCompoentList = [];
      this.TotalTaxRate = 0;
      var item1 = new TaxRateComponentRequestInfo();
      item1.taxRateComponentId = 0;
      item1.taxRateMasterId = 0;
      item1.taxCode = "";
      item1.taxRate = null;
      item1.taxAccountingCode = "";
      this.TaxRateCompoentList.push(item1);
      var item2 = new TaxRateComponentRequestInfo();
      item2.taxRateComponentId = 0;
      item2.taxRateMasterId = 0;
      item2.taxCode = "";
      item2.taxRate = null;
      item2.taxAccountingCode = "";
      this.TaxRateCompoentList.push(item2);
    }
  }
TaxRateBeforeEdit:any;
TaxActiveStatusBeforeEdit:any;
  EditExistingTaxRate(item: TaxRateMasterResponseInfo) {
    this.Submitted = false;
    this.TaxRateMasterId = item.taxRateMasterId;
    this.TaxRateBeforeEdit = item.taxRate.toString() + "%";
    this.TaxCode = item.taxCode;
    this.TaxRate = item.taxRate.toString() + "%";
    this.TaxAccountingCode = item.taxAccountingCode;
    this.EffectiveFrom = item.effectiveFrom;
    this.IsCreateNewTaxRateMaster = false;
    this.IsFutureRate = item.isFutureRate;
    this.FutureRateOf = item.futureRateOf;
    this.TaxActiveStatus = item.isActive;
    this.TaxActiveStatusBeforeEdit = item.isActive;
    this.isTaxCodeAlreadyExists = false;


    if (this.IsFutureRate) {
      this.futureDatePickerOptions = {
        mode: "single",
        defaultDate: new Date(item.effectiveFrom),
        minDate: new Date(
          new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000
        ),
        altInput: true,
        altFormat: "d-M-Y",
        dateFormat: "d-M-Y",
      };

      this.fFrmDate.nativeElement.flatpickr(this.futureDatePickerOptions);
      this.CreateNewTaxHeader = this.translate.instant('edit_future_tax_rate');
      this.TaxRateMasterListForFutureRate = this.TaxRateMasterListOriginal.filter(
        (i) =>
          i.isFutureRate === false &&
          i.isActive === true &&
          i.isExpiredRate === false
      );

      for (var i = 0; i < this.TaxRateMasterListForFutureRate.length; i++) {
        this.TaxRateMasterListForFutureRate[i].taxCodeRate =
          this.TaxRateMasterListForFutureRate[i].taxCode +
          " (" +
          this.TaxRateMasterListForFutureRate[i].taxRate +
          "%)";
      }
    } else {
      this.datePickerOptions = {
        mode: "single",
        defaultDate: new Date(item.effectiveFrom),
        maxDate: new Date(new Date().setHours(23, 59, 59, 999)),
        altInput: true,
        altFormat: "d-M-Y",
        dateFormat: "d-M-Y",
      };

      this.fFrmDate.nativeElement.flatpickr(this.datePickerOptions);
      this.CreateNewTaxHeader = this.translate.instant('edit_existing_tax_rate');
    }

    this.ShowEditPanel = true;
    this.ShowLogPanel = true;
    this.BindTaxRateComponents();
  }

  CreateNewFutureRate() {
    this.Submitted = false;
    this.IsFutureRate = true;
    this.IsCreateNewTaxRateMaster = true;
    this.CreateNewTaxHeader = this.translate.instant('add_future_rate_to_existing_code');
    this.ShowEditPanel = true;

    this.TaxRateMasterId = 0;
    this.TaxCode = null;
    this.TaxRate = null;
    this.TaxAccountingCode = "";
    this.IsCreateNewTaxRateMaster = true;
    this.EffectiveFrom = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    this.fFrmDate.nativeElement.flatpickr(this.futureDatePickerOptions);

    this.TaxRateMasterListForFutureRate = this.TaxRateMasterListOriginal.filter(
      (i) =>
        i.isFutureRate === false &&
        i.isActive === true &&
        i.isExpiredRate === false
    );

    for (var i = 0; i < this.TaxRateMasterListForFutureRate.length; i++) {
      this.TaxRateMasterListForFutureRate[i].taxCodeRate =
        this.TaxRateMasterListForFutureRate[i].taxCode +
        " (" +
        this.TaxRateMasterListForFutureRate[i].taxRate +
        "%)";
    }
    if (!this.IsSingleRate) {
      this.TaxRateCompoentList = [];
      this.TotalTaxRate = 0;
      var item1 = new TaxRateComponentRequestInfo();
      item1.taxRateComponentId = 0;
      item1.taxRateMasterId = 0;
      item1.taxCode = "";
      item1.taxRate = null;
      item1.taxAccountingCode = "";
      this.TaxRateCompoentList.push(item1);
      var item2 = new TaxRateComponentRequestInfo();
      item2.taxRateComponentId = 0;
      item2.taxRateMasterId = 0;
      item2.taxCode = "";
      item2.taxRate = null;
      item2.taxAccountingCode = "";
      this.TaxRateCompoentList.push(item2);
    }
  }

  changeActiveInactive() {
    this.DisableSave = false;
    this.hasFormChanges = true;
  }

  canDeactivate() {
    return !this.hasFormChanges;
  }

  CloseEditPanel(saveType: number) {
    if (!this.canDeactivate()) {
      this.alertService.onFormClosed();
    } else {
      this.ShowEditPanel = false;
      this.ShowLogPanel = false;
      this.hasFormChanges = false;
      if(saveType === 1) {
        this.CreateNewTaxRate();
      }
      else if(this.fmSpecialObject && this.fmSpecialObject.type === 1) {
        this.closePanelEvent.emit(true);
      }
      
    }
  }

  BindTaxRateComponents() {
    var request = new TaxRateComponentRequest();
    request.requestId = "1";
    request.webApiName = "getTaxRateComponents";
    request.webApiVersion = 1;
    request.requestInfo = new TaxRateComponentRequestInfo();
    request.requestInfo.taxRateMasterId = this.TaxRateMasterId;

    this.taxRateService
      .getTaxRateComponentsByMasterId(request, "")
      .pipe()
      .subscribe((data) => {
        if (data.statusCode == 0) {
          this.TaxRateCompoentList = data.responseInfo;

          if(this.TaxRateCompoentList.length === 0 && !this.IsSingleRate) {
            var item1 = new TaxRateComponentRequestInfo();
            item1.taxRateComponentId = 0;
            item1.taxRateMasterId = this.TaxRateMasterId;
            item1.taxCode = "";
            item1.taxRate = null;
            item1.taxAccountingCode = "";
            this.TaxRateCompoentList.push(item1);
            var item2 = new TaxRateComponentRequestInfo();
            item2.taxRateComponentId = 0;
            item2.taxRateMasterId = this.TaxRateMasterId;
            item2.taxCode = "";
            item2.taxRate = null;
            item2.taxAccountingCode = "";
            this.TaxRateCompoentList.push(item2);
          }

          this.TotalTaxRate = this.TaxRateCompoentList.reduce(
            (sum, item) => Number(sum) + Number(item.taxRate),
            0
          );
          this.BindExpiredRateMaster();
          this.BindFutureRateMaster();
        }
      });
  }

  BindFutureRateMaster() {
    var toDay = new Date();

    this.FutureTaxRateMasterList = this.TaxRateMasterListOriginal.filter(
      (d) => d.isFutureRate && d.taxCode === this.TaxCode
    );

    this.ShowFutureRate =
      this.FutureTaxRateMasterList.length > 0 && !this.IsFutureRate;
    setTimeout(() => {
      if (this.componentRateCollapse) {
        this.componentRateCollapse.nativeElement.classList.add('show');
      }
    }, 500);



  }

  BindExpiredRateMaster() {
    var toDay = new Date();

    this.ExpiredTaxRateMasterList = this.TaxRateMasterListOriginal.filter(
      (d) => d.isExpiredRate && d.taxCode === this.TaxCode
    );
    this.ShowExpiredRate =
      this.ExpiredTaxRateMasterList.length > 0 && this.IsFutureRate === false;
  }
  IsDeactivateAciveRate: boolean;
  alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));

  onTaxRateChange() {
    this.hasFormChanges = true;
  }

  onEffectiveFromDateChange(name: string) {
    this.hasFormChanges = true;
    this.EffectiveFrom = new Date(name);
  }

  DeactivateTaxRate() {
    this.TaxRateMasterId = this.currentDeactivatingItem.taxRateMasterId;
    this.TaxCode = this.currentDeactivatingItem.taxCode;
    this.TaxRate = this.currentDeactivatingItem.taxRate.toString() + "%";
    this.TaxAccountingCode = this.currentDeactivatingItem.taxAccountingCode;
    this.EffectiveFrom = this.currentDeactivatingItem.effectiveFrom;
    this.IsCreateNewTaxRateMaster = false;
    this.CreateNewTaxHeader = this.translate.instant('edit_existing_tax_code');
    this.IsFutureRate = this.currentDeactivatingItem.isFutureRate;
    this.BindTaxRateComponents();

    if (!this.IsSingleRate) {
      var tml = this.TaxRateMasterListOriginal.filter(
        (i) => i.taxRateMasterId === this.TaxRateMasterId
      );
      if (tml.length > 0) {
        this.TaxRateCompoentList = tml[0].taxRateComponent;
        this.TotalTaxRate = this.TaxRateCompoentList.reduce(
          (sum, item) => Number(sum) + Number(item.taxRate),
          0
        );
      }
    }
    this.DisableSave = false;
    this.SaveTaxRateMaster(!this.currentDeactivatingItem.isActive);
    this.DesctivateConfirmation = false;
  }
  updatedDateTime: any;
  TaxRateText: string;
  onTaxAccountingCodeChange() {
    this.hasFormChanges = true;
  }
  SaveTaxRateComponents(taxRateMasterId) {

    this.taxRateComponentSaveRequest = new TaxRateComponentSaveRequest();
    this.taxRateComponentSaveRequest.requestId = "1";
    this.taxRateComponentSaveRequest.webApiName = "saveTaxRateComponents";
    this.taxRateComponentSaveRequest.webApiVersion = 1;
    for (var i = 0; i < this.TaxRateCompoentList.length; i++) {
      this.TaxRateCompoentList[i].taxRateMasterId = taxRateMasterId;
    }
    this.taxRateComponentSaveRequest.requestInfo = this.TaxRateCompoentList.filter(
      (item) => item.taxCode.toString().replace('%', '') != "" && Number(item.taxRate.toString().replace('%', '')) >= 0
    );

    this.taxRateService
      .saveTaxRateComponent(this.taxRateComponentSaveRequest, "")
      .pipe()
      .subscribe((data) => {
        if (data.statusCode == 0) {
           if(this.TaxRateMasterId > 0) {
              this.toastr.success(this.translate.instant("success"));
            }
            else
            {
              this.toastr.success(this.translate.instant("self_setup_msg_4"));
            }
          this.ShowEditPanel = false;
          this.DisableSave = false;
          this.BindTaxRateMaster();
          this.CloseEditPanel(this.saveType);
        }
      });
  }
alertPanelModelForTaxChange = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
isActiveDeactive:any;
saveType: number = 0;
fnCheckForTaxRateChanges(IsActiveDeactive,type:number)
{
  this.saveType = type;
  this.Submitted = true;

  if (
      this.TaxRate == null || this.TaxRate == ""  ||
      Number(this.TaxRate.toString().replace("%", "")) < 0
    ) {
      return;
    }
  if (this.TaxRateBeforeEdit?.replace('%', '') != this.TaxRate?.replace('%', '') && !this.IsFutureRate && this.TaxActiveStatusBeforeEdit) {
    this.isActiveDeactive = IsActiveDeactive;
    this.fnTaxChangeAlert();
    
  } else {
    this.SaveTaxRateMaster(IsActiveDeactive);
  }
}
fnTaxChangeAlert() {
    this.alertPanelModelForTaxChange = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [this.translate.instant('tax_change_validation_msg'),this.translate.instant('additional_field_confirmation_message')],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true
      ,''
    );

  }
   alertPanelReceiverForTaxChange(returnValue) {
    if (returnValue) {
      this.SaveTaxRateMaster(this.isActiveDeactive);
    }
    this.alertPanelModelForTaxChange = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  }
  SaveTaxRateMaster(IsActiveDeactive) {

    this.Submitted = true;


    if (this.isTaxCodeAlreadyExists) {
      return;
    }

    if (!this.IsSingleRate) {
      if (
        Number(this.TaxRate.toString().replace("%", "")) != this.TotalTaxRate
      ) {
        this.showTaxRateValidation = true;
        return;
      }
    }
    if (
      this.TaxCode == null || this.TaxCode == "" ||
      this.EffectiveFrom == null || this.EffectiveFrom == 'Invalid Date' ||
      Number(this.TaxRate.toString().replace("%", "")) < 0
    ) {
      return;
    }

    let taxRates = this.TaxRateMasterList.filter(
      (item) =>
        item.taxCode == this.TaxCode &&
        item.taxRate == Number(this.TaxRate.toString().replace("%", "")) &&
        new Date(item.effectiveFrom).toDateString() ==
        new Date(this.EffectiveFrom).toDateString()
    );

    if (taxRates.length > 1) {
      this.showDuplicateTaxRateValidation = true;
      return;
    } else {
      this.showDuplicateTaxRateValidation = false;
    }


    if (!this.IsSingleRate) {
      if (
        this.TaxRateCompoentList.filter(
          (i) => i.taxRate.toString().trim() === ""
        ).length > 0 ||
        this.TaxRateCompoentList.filter(
          (i) => i.taxCode.toString().trim() === ""
        ).length > 0
      ) {
        return;
      }
    }
    this.DisableSave = true;
    this.sortOrderDesc = true;

    this.updatedDateTime = new Date().toUTCString();

    if (this.TaxRateMasterId == 0) {
      this.sortColumn = "CreatedOn";
    } else {
      this.sortColumn = "UpdatedOn";
    }

    this.TaxRateMasterRequestInfo = new TaxRateMasterRequestInfo();
    this.TaxRateMasterRequestInfo.taxRateMasterId = this.TaxRateMasterId;
    this.TaxRateMasterRequestInfo.organisationId = this.OrganisationId;
    this.TaxRateMasterRequestInfo.taxCode = this.TaxCode;
    this.TaxRateMasterRequestInfo.taxRate = Number(
      this.TaxRate.toString().replace("%", "")
    );
    this.TaxRateMasterRequestInfo.taxAccountingCode = this.TaxAccountingCode;
    this.TaxRateMasterRequestInfo.isActive = IsActiveDeactive;
    if (this.IsFutureRate) {
      this.TaxRateMasterRequestInfo.isFutureRate = true;
      this.TaxRateMasterRequestInfo.futureRateOf = this.FutureRateOf;
    } else {
      this.TaxRateMasterRequestInfo.isFutureRate = false;
      this.TaxRateMasterRequestInfo.futureRateOf = 0;
    }
    this.TaxRateMasterRequestInfo.effectiveFrom = this.getUTCTimeStamp(
      new Date(this.EffectiveFrom)
    ).toISOString();
    this.TaxRateMasterRequestInfo.createdBy = this.claims.UserId;
    this.TaxRateMasterRequestInfo.updatedBy = this.claims.UserId;
    this.TaxRateMasterRequestInfo.sortColumn = this.sortColumn;

    this.TaxRateMasterRequest = new TaxRateMasterRequest();
    this.TaxRateMasterRequest.requestId = "1";
    this.TaxRateMasterRequest.webApiName = "SaveTaxRateMaster";
    this.TaxRateMasterRequest.webApiVersion = 1;
    this.TaxRateMasterRequest.requestInfo = this.TaxRateMasterRequestInfo;
    this.taxRateService
      .saveTaxRateMaster(this.TaxRateMasterRequest, "")
      .subscribe((data) => {
          this.hasFormChanges = false;
          this.Submitted = false;
        if (data.statusCode == 0) {
          this.ShowDataInGrid = this.TaxRateMasterList.length > 0;
          if(this.fmSpecialObject)
          {
            this.fmSpecialObject.nextPanel = true;
          }
          if (!this.IsSingleRate) {
            this.SaveTaxRateComponents(data.responseInfo?.taxRateMasterId);
            this.showTaxRateValidation = false;
          } else {
            if(this.TaxRateMasterId > 0) {
              this.toastr.success(this.translate.instant("success"));
            }
            else
            {
              this.toastr.success(this.translate.instant('self_setup_16_msg_40'));
            }
            
            this.ShowEditPanel = false;
            this.DisableSave = false;
            this.showTaxRateValidation = false;
            this.CloseEditPanel(this.saveType);
          }
          
          this.BindTaxRateMaster();
        }
      });
  }

  getUTCTimeStamp(date) {
    let now_utc = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0
    );

    return new Date(now_utc);
  }

  CloseInfoPopup() {
    this.IsDeactivateAciveRate = false;
  }

  alertPanelReceiver(returnValue) {
    if (returnValue) {
      if (this.IsDeactivateAciveRate) {
        this.CloseInfoPopup();
      }
      else {
        this.DeactivateTaxRate();
      }
    }
    this.DesctivateConfirmation = false;
    this.IsDeactivateAciveRate = false;
    this.alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  }
 

  taxCodeChange(newTaxCode) {

    this.hasFormChanges = true;
    if (this.TaxRateMasterId === 0) {
      var itemsWithSameTaxCode = this.TaxRateMasterListOriginal.filter(
        (i) =>
          i.taxCode.toUpperCase() === newTaxCode.toUpperCase() &&
          i.isFutureRate === false
      );
      if (itemsWithSameTaxCode.length > 0) {
        this.isTaxCodeAlreadyExists = true;
      } else {
        this.isTaxCodeAlreadyExists = false;
      }
    } else {
      var itemsWithSameTaxCode = this.TaxRateMasterListOriginal.filter(
        (i) =>
          i.taxCode.toUpperCase() === newTaxCode.toUpperCase() &&
          i.isFutureRate === false &&
          i.taxRateMasterId !== this.TaxRateMasterId
      );
      if (itemsWithSameTaxCode.length > 0) {
        this.isTaxCodeAlreadyExists = true;
      } else {
        this.isTaxCodeAlreadyExists = false;
      }
    }
  }

  setTaxMasterForFutureRate(event: TaxRateMasterResponseInfo) {
    this.hasFormChanges = true;

    this.TaxRate = event.taxRate.toString() + "%";
    this.TaxCode = event.taxCode;
    this.TaxAccountingCode = event.taxAccountingCode;
    this.FutureRateOf = event.taxRateMasterId;

    if (!this.IsSingleRate) {
      var taxRateC = this.TaxRateMasterListOriginal.filter(
        (i) => i.taxRateMasterId === event.taxRateMasterId
      );

      if (taxRateC.length > 0) {
        this.TaxRateCompoentList = [];
        for (var i = 0; i < taxRateC[0].taxRateComponent.length; i++) {
          var item1 = new TaxRateComponentRequestInfo();
          item1.taxRateComponentId = 0;
          item1.taxRateMasterId = 0;
          item1.taxCode = taxRateC[0].taxRateComponent[i].taxCode;
          item1.taxRate = taxRateC[0].taxRateComponent[i].taxRate;
          item1.taxAccountingCode =
            taxRateC[0].taxRateComponent[i].taxAccountingCode;
          this.TaxRateCompoentList.push(item1);
        }
      }

      this.TotalTaxRate = this.TaxRateCompoentList.reduce(
        (sum, item) => Number(sum) + Number(item.taxRate),
        0
      );
    }
  }

  DeactivateExistingTaxRate(item) {

    this.currentDeactivatingItem = item;

    this.DesctivateConfirmationHeader = this.translate.instant('delete_future_tax_rate');
    this.DesctivateConfirmationText =
      this.translate.instant('would_you_like_to_delete_future_tax');
    this.DesctivateConfirmation = true;
    this.alertPanelModel = new AlertPanelModel(
      true,
      this.DesctivateConfirmationHeader,
      [],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true
      , this.DesctivateConfirmationText
    );

  }

  fnStartTour(){
    const showTour = Boolean(this.route.snapshot.queryParams?.showTour);
    if (!showTour) return;
    this.tourService.showParallelFromRegistry('setup-tax-rates-codes-panel-tour');
  }
  

}